import { Id, Navigation } from '@centra';

import { showroomApi } from '../services/api';

export const fetchCmsNavigation = async () => showroomApi.GET('/cms/navigation')({});

export const fetchCmsBuyerNavigation = async (buyer?: Id) => showroomApi.QUERY_POST('/navigation')({ data: { buyer } });

export const updateCmsNavigation = async (items: Navigation.AnyMenuItem[]) => showroomApi.PUT('/cms/navigation')({ data: { items } });
